import { render } from "./resumeCRMWhatsappConversationDialog.vue?vue&type=template&id=3bec66b8"
import script from "./resumeCRMWhatsappConversationDialog.vue?vue&type=script&lang=js"
export * from "./resumeCRMWhatsappConversationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__